import React from "react";
import PropTypes from "prop-types";
import Moment from "moment";
import { path } from "ramda";
import { connect } from "react-redux";
import { ReducerKeys } from "../../reducers";
import SettingReducer from "../../reducers/SettingReducer";
import I18n from "../../i18n/";
import Layout from "../../components/layout/Layout";
import CompareValuePanel, { CompareCol, TargetValueType } from "./CompareValuePanel";
import ReportAction from "../../actions/ReportAction";
import ReportGenericPanel from "./ReportGenericPanel";
import { ArrayUtil, DateUtil, ReportUtil } from "../../util";
import { withCompareDate } from "../../hoc/";

class ReportGeneric extends React.Component{
    comparePanel = {
    	main:null,
    	[TargetValueType.Primary]:null,
    	[TargetValueType.Secondary]:null,
    };
	mainValuePick = {
		[TargetValueType.Primary]:undefined,
    	[TargetValueType.Secondary]:undefined
	}
    primaryFetchValue = { 
    	main:undefined,
    	select:undefined
    };
    onPrimaryFetched = (isMain, data, shouldUpdate)=>{
    	const { typeKey } = this.props;
    	if(isMain){
    		this.primaryFetchValue = {
    			main:data
    		};
    	}else{
    		this.primaryFetchValue.select = data;
    	}
    	if(shouldUpdate){
    		this.forceUpdate();
    		if(this.comparePanel[TargetValueType.Secondary]!==null){
    			this.comparePanel[TargetValueType.Secondary].forceUpdate();
    		}
    	}
    }
    internalFetchMain = (type = TargetValueType.Primary)=>{
    	const { fetchMain, getMomentDateFromType } = this.props;
    	return fetchMain({dateRange:getMomentDateFromType(type)});
    }
    internalFetchSelect = (type = TargetValueType.Primary, select, errorOnInfo = true)=>{
    	const { fetchSelect, selectValueName, getMomentDateFromType } = this.props;
    	return fetchSelect({dateRange:getMomentDateFromType(type), [selectValueName]:select, errorOnInfo});
    }
	onMainValuePick = (type, value)=>{
		this.mainValuePick[type] = value;
	}
    onPrimaryDateChanged = (date)=>{
    	const type = TargetValueType.Primary;
    	this.forceUpdate(()=>{
    		this.comparePanel[type].updateMain(this.internalFetchMain(type));
    	});
    }
    onSecondaryDateChanged = (date)=>{
    	const type = TargetValueType.Secondary;
    	this.comparePanel.main.setShowCompare(ArrayUtil.isAliveArray(date));
    	this.forceUpdate(()=>{
    		if(date.length>0){
    			this.comparePanel[type].updateMain(
    				this.internalFetchMain(type)
    			);
    		}
    	});
    }
    render(){
    	const { typeKey, itemToBreadcrumbName, itemToPassSelect, getAutoSelectItem, exclude, beforeCompareComp,
    		drawSingleGraph, drawListGraph, header, subHeader, mainReadKey,
    		getExportAll, getExportPromise, getExportComparePromise,
    		PanelDrawer = ReportGenericPanel, headKeys, getMomentReportDate,
    		pushOnTypeClick
    	} = this.props;
    	const dateRange = getMomentReportDate();
    	const showCompare = ArrayUtil.isAliveArray(dateRange[TargetValueType.Secondary]);
    	return(<Layout>
    		{beforeCompareComp}
    		<CompareValuePanel 
    			setRef={(ref)=>{this.comparePanel.main = ref;}} 
    			header={header}
    			subHeader={subHeader} 
    			showSecondaryDatePicker
    			getExportAll={getExportAll}
    			getExportPromise={getExportPromise}
    			getExportComparePromise={getExportComparePromise}
    			// primaryDate={this.dateRanges[TargetValueType.Primary]}
    			// secondaryDate={this.dateRanges[TargetValueType.Secondary]}
    			onPrimaryDateChanged={this.onPrimaryDateChanged}
    			onSecondaryDateChanged={this.onSecondaryDateChanged}
    			getMainPickValue={()=>this.mainValuePick}
    			primaryComponent = {
    				<PanelDrawer 
    					setRef={ref=>{this.comparePanel[TargetValueType.Primary] = ref;}}
    					header={subHeader}
    					typeKey={typeKey}
    					headKeys={headKeys}
    					targetValueType = {TargetValueType.Primary}
    					isVertical={showCompare}
    					dateRange={dateRange[TargetValueType.Primary]}
    					fetchMain={this.internalFetchMain}
    					fetchSelect={this.internalFetchSelect}
    					onMainValuePick = {this.onMainValuePick}
    					pushOnTypeClick = {pushOnTypeClick}
    					getAutoSelectItem={getAutoSelectItem}
    					itemToBreadcrumbName={itemToBreadcrumbName}
    					itemToPassSelect={itemToPassSelect}
    					exclude={exclude}
    					onFetched={this.onPrimaryFetched}
    					mainReadKey={mainReadKey}
    					drawSingleGraph={drawSingleGraph}
    					drawListGraph={drawListGraph}
    				/>
    			}
    			secondaryComponent = {
    				<PanelDrawer 
    					setRef={ref=>{this.comparePanel[TargetValueType.Secondary] = ref;}}
    					header={subHeader}
    					typeKey={typeKey}
    					headKeys={headKeys}
    					previousFetch={this.primaryFetchValue}
    					targetValueType = {TargetValueType.Secondary}
    					isVertical={showCompare}
    					dateRange={dateRange[TargetValueType.Secondary]}
    					fetchMain={this.internalFetchMain}
    					fetchSelect={this.internalFetchSelect}
    					onMainValuePick = {this.onMainValuePick}
    					pushOnTypeClick = {pushOnTypeClick}
    					getAutoSelectItem={getAutoSelectItem}
    					itemToBreadcrumbName={itemToBreadcrumbName}
    					itemToPassSelect={itemToPassSelect}
    					exclude={exclude}
    					mainReadKey={mainReadKey}
    					drawSingleGraph={drawSingleGraph}
    					drawListGraph={drawListGraph}
    				/>
    			}
    		/>
    	</Layout>);
    }
}
ReportGeneric.defaultProps = {
	selectValueName: "value",
	getAutoSelectItem: undefined,
	itemToBreadcrumbName: undefined,
	itemToPassSelect: undefined,
	headKeys: undefined,
	getExportPromise: undefined,
};
ReportGeneric.propTypes = {
	header:      PropTypes.string.isRequired,
	subHeader:   PropTypes.string.isRequired,
	typeKey:     PropTypes.string,
	headKeys:    PropTypes.arrayOf(PropTypes.string),
	fetchMain:   PropTypes.func.isRequired,
	fetchSelect: PropTypes.func,
	exclude:     PropTypes.arrayOf(PropTypes.string),
	pushOnTypeClick: PropTypes.bool,
	getExportComparePromise: PropTypes.func,
	getExportAll:		  PropTypes.func,
	getExportPromise:	  PropTypes.func,
	mainReadKey:          PropTypes.string,
	selectValueName:      PropTypes.string,
	getAutoSelectItem:    PropTypes.func,
	itemToBreadcrumbName: PropTypes.func,
	itemToPassSelect:     PropTypes.func,
	beforeCompareComp:    PropTypes.element,
	drawSingleGraph:      PropTypes.func,
	drawListGraph:        PropTypes.func,
	
};

export default withCompareDate(ReportGeneric);


// WEBPACK FOOTER //
// ./src/containers/ReportPanels/ReportGeneric.js